import Swiper from 'swiper';
import { handleSwiperProgressBar } from '../modules/swiperModules';

const sections = document.querySelectorAll('section.products-slider');

if (sections.length) {
    sections.forEach(section => {
        const swiperElement = section.querySelector('.swiper');
        if (swiperElement) {
            const paginationEl =
                swiperElement.querySelector('.slider-pagination');

            let args = {
                breakpoints: {
                    0: {
                        slidesPerView: 1.08,
                        slidesPerGroup: 1,
                        spaceBetween: 16,
                    },
                    576: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        spaceBetween: 16,
                    },
                    1023.98: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                        spaceBetween: 20,
                    },
                },
            };
            const swiper = new Swiper(swiperElement, args);

            if (paginationEl) {
                handleSwiperProgressBar(paginationEl, swiper);
            }
        }
    });
}
